<template>
  <v-app>
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>


<script>
// import HelloWorld from './components/HelloWorld';
import io from "socket.io-client";
import User from "@/services/Users";
import isEmpty from "@/outils/isEmpty";
import router from "@/routes";
import Node from "./services/NodeData";
export default {
  name: "App",

  components: {
    // HelloWorld,
  },

  data: () => ({
   // socket: null
  }),
  created() {
   
    if (isEmpty(localStorage.getItem("authToken"))) router.push("/login");
    else {
      this.$store.state.tk = localStorage.getItem("authToken");
      if (this.$store.commit("checktoken") == false) router.push("/login");
    }
    //add historique
    // Node.getNodes().then((res) => {
    //   for (var i = 0; i < res.length; i++) {
    //    Node.sensor(res[i].NodeId)
    //    .then(res => { console.log(res);})
    //    .catch(er => console.log(er));
    //   }
    // });
    // get by date 
    //  Node.getNodes().then((res) => {
    //   for (var i = 0; i < res.length; i++) {
    //    Node.sensor_by_date(res[i].NodeId,"2023-01-01","2023-01-02")
    //    .then(rest => {
    //     console.log(rest);
    //     })
    //    .catch(er => console.log(er));
    //   }
    // });
    //get latest
    // Node.getNodes().then((res) => {
    //   for (var i = 0; i < res.length; i++) {
    //    Node.sensor_get_latest(res[i].NodeId)
    //    .then(rest => {
    //     console.log(rest);
    //     })
    //    .catch(er => console.log(er));
    //   }
    // });
    //get last week
    // Node.getNodes().then((res) => {
    //   for (var i = 0; i < res.length; i++) {
    //    Node.sensor_get_last_month(res[i].NodeId)
    //    .then(rest => {
    //     console.log(rest);
    //     })
    //    .catch(er => console.log(er));
    //   }
    // });
    // Node.getNodes().then((res) => {
    //   for (var i = 0; i < res.length; i++) {
    //    Node.sensor_get_last_week(res[i].NodeId)
    //    .then(rest => {
    //     console.log(rest);
    //     })
    //    .catch(er => console.log(er));
    //   }
    // });
    // Node.getNodes().then((res) => {
    //   for (var i = 0; i < res.length; i++) {
    //    Node.sensor_get_last_twoDays(res[i].NodeId)
    //    .then(rest => {
    //     console.log(rest);
    //     })
    //    .catch(er => console.log(er));
    //   }
    // });
  },
/*   updated() {
    this.socket = io("https://agriedge.ca/irrig_all/", {
      query: { user: localStorage.getItem("authToken") }
    });
    this.socket.on("Warning", data => {
      alert(data.message);
    });
  } */
};
</script>

<style scoped>
.y {
  width: 100%;
  height: 100%;
  background-position: center;
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("./assets/img/Data-Field.jpg");
}
.y background-image {
  filter: blur(4px);
}
</style>
